// ----------------------- availability.js -----------------------
/**
 * Permet de récupérer un availability-date avec les données produit à partir d'un handle défini de manière asynchrone
 * (cas des app de recherche ou de facettes)
 */
class AvailabilityBlock extends HTMLElement {
    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["data-product-handle"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (newValue) this.url = newValue;

        this.getProductInfos(newValue);
    }

    /* Inject data */
    async getProductInfos(url) {
        const html = await fetch(url + "/?sections=availability-wrapper").then((response) => response.json());

        const div = document.createElement("div");
        div.innerHTML = html["availability-wrapper"];
        this.append(div);
    }
}

customElements.define("availability-block", AvailabilityBlock);

/*Affichage date */
class AvailabilityDate extends HTMLElement {
    constructor() {
        super();
        // propriétés fiches produit
        this.productRef = this.getAttribute("product-ref");
        this.variantRef = this.getAttribute("variant-ref");
        this.displayButton = this.getAttribute("display-button");
        this.currentVariant = this.getAttribute("current-variant");

        // si on est pas sur une fifche produit on affiche simpelment la date
        if (!this.variantRef) this.style.display = "flex";

        this.setDisplay();
    }

    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["current-variant"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "current-variant":
                this.currentVariant = this.getAttribute("current-variant");
                this.setDisplay();

                break;
        }
    }

    // Selectionne la date à afficher et affiche le bouton acheter en focntion du variant selectionné
    setDisplay() {
        const buyButtons = document.querySelectorAll(
            `[availability-display="${this.productRef}"], [availability_display="${this.productRef}"]`
        );

        if (this.currentVariant === this.variantRef) {
            this.style.display = "flex";
            const display = this.displayButton === "true" ? "block" : "none";

            buyButtons.forEach((button) => {
                button.style.display = display;
            });
        } else {
            //this.style.display = 'none';
        }
    }
}

customElements.define("availability-date", AvailabilityDate);

// récupoère le paramètre href des élements dynamqiues
class AvailabilityTarget extends HTMLElement {
    constructor() {
        super();

        /* Nf : update webcomponent*/
        const a = this.querySelector("[data-product-title]");
        const url = a.getAttribute("href");

        if (!url) return;

        /* Nf : update webcomponent*/
        const handle = this.querySelector("[data-product-handle]");
        const handleUrl = url.replace(/\?variant=\d+/, "");
        handle.setAttribute("data-product-handle", handleUrl);
    }
}

customElements.define("availability-target", AvailabilityTarget);

/**
 * Se place sur le champ input du product form qui est mis à jour lors de la sélection d'un variant
 *    <input is="availability-referer" product-ref="{{ product.id }}" type="hidden" disabled name="id" value="{{ product.selected_or_first_available_variant.id }}">
 * Permet de mettre à jour les availability-dates concernés
 */
class AvailabilityReferer extends HTMLInputElement {
    constructor() {
        super();
        this.productRef = this.getAttribute("product-ref");
    }
    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["value"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (newValue) {
            this.propagate(newValue);
        }
    }

    /* Inject data */
    propagate(newValue) {
        const targets = document.querySelectorAll(`availability-date[product-ref="${this.productRef}"]`);
        targets.forEach((elem) => {
            elem.setAttribute("current-variant", newValue);
        });
    }
}

customElements.define("availability-referer", AvailabilityReferer, {
    extends: "input",
});

/* -----------------------------------------
   1) GÈRE L’OUVERTURE / FERMETURE DU POPUP
----------------------------------------- */
function initPopupEvents() {
    const popup = document.getElementById('popup-plante-pot');
    if (!popup) return;

    const btn = document.querySelector('.vv-btn-ajouter-pltp');
    const overlay = popup.querySelector('.popup__overlay');
    const closeBtn = popup.querySelector('.popup__close');

    // Reset listeners
    if (overlay) overlay.replaceWith(overlay.cloneNode(true));
    if (closeBtn) closeBtn.replaceWith(closeBtn.cloneNode(true));

    const newOverlay = popup.querySelector('.popup__overlay');
    const newClose = popup.querySelector('.popup__close');

    if (btn) {
        btn.onclick = () => {
            popup.classList.remove('hidden');

            // Fix slider ready
            setTimeout(() => initPotScroller(), 80);
        };
    }

    [newOverlay, newClose].forEach(el => {
        if (el) el.onclick = () => popup.classList.add('hidden');
    });

    const quickForms = popup.querySelectorAll('.product-item__quick-form');

    quickForms.forEach(form => {
        form.addEventListener('submit', () => {

            // Attendre 2,5 secondes AVANT de commencer le fade-out
            setTimeout(() => {

                popup.style.opacity = "1";
                popup.style.transition = "opacity 0.35s ease";

                setTimeout(() => {
                    popup.style.opacity = "0";
                }, 10);

                setTimeout(() => {
                    popup.classList.add('hidden');
                    popup.style.opacity = "";
                    popup.style.transition = "";
                }, 360);

            }, 2000);

        });
    });
}
/* -----------------------------------------
   2) SLIDER / ARROWS
----------------------------------------- */
function initPotScroller() {
    const slider = document.querySelector('#popup-plante-pot .vv-slide-popup');
    const prev = document.querySelector('#popup-plante-pot .vv-btn-prev');
    const next = document.querySelector('#popup-plante-pot .vv-btn-next');

    if (!slider || !prev || !next) return;

    const items = slider.children.length;

    /* -----------------------------
       1) CAS : 1 SEUL PRODUIT
    ----------------------------- */
    if (items <= 1) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
    }

    /* -----------------------------
       2) CAS : 2+ PRODUITS
    ----------------------------- */
    prev.style.display = 'flex';
    next.style.display = 'flex';

    // Nettoyage listeners
    prev.replaceWith(prev.cloneNode(true));
    next.replaceWith(next.cloneNode(true));

    const newPrev = document.querySelector('#popup-plante-pot .vv-btn-prev');
    const newNext = document.querySelector('#popup-plante-pot .vv-btn-next');

    const move = () => slider.clientWidth * 0.95;

    /* -----------------------------
       initialButtons()
    ----------------------------- */
    function initialButtons() {
        // Au début du slider :
        newPrev.style.opacity = '0';   
        newNext.style.opacity = '1'; 
    }

    function updateButtons() {
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

        newPrev.style.opacity = slider.scrollLeft <= 5 ? '0' : '1';
        newNext.style.opacity = slider.scrollLeft >= maxScrollLeft - 5 ? '0' : '1';
    }

    /* -----------------------------
       Click events
    ----------------------------- */
    newNext.onclick = () => {
        slider.scrollBy({ left: move(), behavior: 'smooth' });
        setTimeout(updateButtons, 150);
    };

    newPrev.onclick = () => {
        slider.scrollBy({ left: -move(), behavior: 'smooth' });
        setTimeout(updateButtons, 150);
    };

    slider.addEventListener('scroll', updateButtons);

    /* -----------------------------
       FORCE LES BONNES VALEURS
    ----------------------------- */
    setTimeout(() => {
        initialButtons(); 
        updateButtons();   
    }, 80);
}

/* -----------------------------------------
   4) INIT AU LOAD
----------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    initPopupEvents();
    initPotScroller();
});

// js/custom-element/section/product/payment-container.js
var PaymentContainer = class extends HTMLElement {
    constructor() {
        super();
        this._onVariantChanged();
    }

    connectedCallback() {
        var _a;
        (_a = document.getElementById(this.getAttribute("form-id"))) == null
            ? void 0
            : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
        if (Shopify.designMode && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
        }
    }
    _onVariantChanged(event) {
            let id;
            const vv_block_swatch_radio = document.querySelectorAll(".block-swatch__radio");
        
            if (event) id = event.detail.variant.id;
            else id = document.querySelector(`availability-date[current-variant]`).getAttribute("current-variant");
        
            // Nf : permet de s'assurer de l'execution des autres web-components dans la page
            setTimeout(() => {
                const availabilityReferer = document.querySelector(`availability-date[variant-ref="${id}"]`);
                const availabilityAddToCart = availabilityReferer.getAttribute("display-button");
                
                this._updateAddToCartButton(/*event.detail.variant, */ availabilityAddToCart);
                this._updateDynamicCheckoutButton(/*event.detail.variant, */ availabilityAddToCart);
                this._vv_updateSetAddToCartLimit();
                this._vv_updateFlagVisibility();
            }, 0);

            let checkedRadio = document.querySelector('.vv-new-block-swatch__radio:checked');
            let variationImageDiv = document.querySelector('.vv-variation-image');
            let oldPriceSpan = document.querySelector('.vv-old-price span'); 
            let valideSinceSpan = document.querySelector('.vv-valide-since span'); 
            let PrixEnBaisse = document.querySelector('.vv-picto-price');
            let blockPrice = document.querySelector('.vv-variation-price');

            if (checkedRadio) {
            let getImageQl = checkedRadio.getAttribute("vv-imageql");
            if (getImageQl) {
                blockPrice.classList.remove('vv-variation-price-mobile');
            } else {
                blockPrice.classList.add('vv-variation-price-mobile');
            }
            }

            if (checkedRadio) {
            // Sélection du bloc de prix
            let blockPrice = document.querySelector(".vv-right-price-from-product ");

            if (!blockPrice) {
                return;
            }

            // Récupérer la valeur de data-vv-product-info
            let vvProductInfo = blockPrice.getAttribute("data-vv-product-info") === "true";
            let vvNumberPromo = checkedRadio.getAttribute("vv-variant-promo");

            //Promo
            let vvSectionPromo = blockPrice.querySelector(".right-price-container");
            let vvPromo = blockPrice.querySelector(".vv-promo-compare");
            
            if (vvProductInfo && !vvPromo && vvSectionPromo ) {

                vvSectionPromo.classList.add("vv-promo-with-compare-at-price-change");
                // Sélectionner le span existant
                let priceCompareSpan = vvSectionPromo.querySelector(".price__compare-container");
            

                // Vérifier si l'élément existe et si vvNumberPromo n'a pas déjà été ajouté
                if (priceCompareSpan && vvNumberPromo) {
                    let existingPromoNumber = vvSectionPromo.querySelector(".vv-price-list__compare-container-info");
                    if (!existingPromoNumber) {  // Ajouter seulement si ça n'existe pas déjà
                        priceCompareSpan.insertAdjacentHTML("afterend", `
                            <div class="price-list__compare-container vv-price-list__compare-container-info">
                                <span class="label label--highlight vv-price-info-promo">-${vvNumberPromo}</span>
                            </div>
                        `);
                    }
                }
            } else {
            if (vvSectionPromo) {
                vvSectionPromo.classList.remove("vv-promo-with-compare-at-price-change");
            }
            }

            
            // Ajouter ou retirer la classe sur blockPrice
            if (vvProductInfo) {
                blockPrice.classList.add("vv-right-price-from-product");
            } else {
                blockPrice.classList.remove("vv-right-price-from-product");
            }

            // Gestion de price-list__compare-container
            let compareContainer = document.querySelector(".price-list__compare-container");
            if (compareContainer) {
                compareContainer.style.display = vvProductInfo ? "none" : "block";
            }

            // Toujours afficher .vv-promo et son contenu
            let promoContainer = document.querySelector(".vv-promo");
            if (promoContainer) {
                promoContainer.style.display = "block"; // Toujours affiché
            }

            // Gestion de vv-promo-compare
            let promoCompareDiv = document.querySelector(".vv-promo-compare");
            if (promoCompareDiv) {
                let vvProductInfo1 = promoCompareDiv.getAttribute("data-vv-product-info") === "true";

                if (vvProductInfo1) {
                promoCompareDiv.classList.add("vv-promo-with-compare-at-price");
                } else {
                promoCompareDiv.classList.remove("vv-promo-with-compare-at-price");
                }
            }

            // Vérifier l'attribut data-vv-product-info sur priceCompareSpan
            let priceCompareSpan = document.querySelector(".price__compare-container");
            if (priceCompareSpan) {
                let vvProductInfo2 = priceCompareSpan.getAttribute("data-vv-product-info");
                if (vvProductInfo2 !== null) {
                vvProductInfo2 = vvProductInfo2 === "true";
                priceCompareSpan.style.textAlign = vvProductInfo2 ? "start" : "";
                }
            }

            // Vérification de la présence de compareInfoContainer
            let compareInfoContainer = document.querySelector(".price-list__compare-container.vv-price-list__compare-container-info");
            if (compareInfoContainer) {
                compareInfoContainer.style.display = vvProductInfo ? "block" : "none"; // Affiché ou masqué selon vvProductInfo
            }
            }

            if (checkedRadio && variationImageDiv) {
                let valeur = checkedRadio.getAttribute("vv-imageql");
                let oldPrice = checkedRadio.getAttribute("vv-variant-old-price"); 
                let valideSince = checkedRadio.getAttribute("vv-variant-dep"); 
                let imgVariantTag = variationImageDiv.querySelector('img');


                if (imgVariantTag) {
                    if (valeur) {
                        imgVariantTag.setAttribute('src', valeur);
                        imgVariantTag.setAttribute('data-variant-value', checkedRadio.value);
                        imgVariantTag.style.display = "block";

                        let variantValue = imgVariantTag.getAttribute('data-variant-value');
                        let variantPopup = document.querySelector('.vv-variant-popup');
                        if (variantPopup) {
                            variantPopup.textContent = variantValue;
                        }
                    } else {
                        imgVariantTag.style.display = "none";
                    }
                }

                if (oldPrice && oldPriceSpan) {
                    oldPriceSpan.textContent = 'Ancien prix : ' + oldPrice;
                    PrixEnBaisse.style.display = "block";
                } else if (oldPriceSpan) {
                    oldPriceSpan.textContent = ''; 
                    PrixEnBaisse.style.display = "none";
                }
            }
            /*Begin Changement de variant pour plante pot*/
                    const variant = event && event.detail && event.detail.variant ? event.detail.variant : null;
                    if (!variant || !variant.id) return;

                    const containerMobile = document.querySelector('#vv-pot-container');
                    const containerDesktop = document.querySelector('#popup-plante-pot');

                    if (!containerMobile && !containerDesktop) return;

                    if (containerMobile) {
                        containerMobile.setAttribute('data-variant-id', variant.id);
                    }

                    const url = window.location.pathname + '?variant=' + variant.id + '&section_id=main-product';

                    // Fermer popup si ouvert
                    const popup = document.getElementById('popup-plante-pot');
                    if (popup && !popup.classList.contains('hidden')) {
                        popup.classList.add('hidden');
                    }

                    fetch(url)
                        .then(res => res.text())
                        .then(html => {

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            // MOBILE
                            const newMobile = doc.querySelector('#vv-pot-container');
                            if (containerMobile && newMobile) {
                                containerMobile.innerHTML = newMobile.innerHTML;
                            }

                            // DESKTOP
                            const newDesktop = doc.querySelector('#popup-plante-pot');
                            if (containerDesktop && newDesktop) {
                                containerDesktop.innerHTML = newDesktop.innerHTML;
                            }

                            // Ré-initialise slider + popup events
                            initPopupEvents();
                            initPotScroller();
                        })
                        .catch(err => console.error("Erreur lors du rechargement des produits :", err));
    }
  
    _vv_updateFlagVisibility() {
        const selectedVariant = document.querySelector('.block-swatch input[type="radio"]:checked');
        const toggleFlagVisibility = (flag, condition) => {
            const element = document.querySelector(`.${flag}`);
            if (element) {
              element.classList.toggle("hidden-tag", !condition);
            }
        };
        if (selectedVariant) {
            toggleFlagVisibility("vv-flag--falling-price", selectedVariant.hasAttribute('vv-flag--falling-price') && !selectedVariant.hasAttribute('vv-flag--promotion'));
            toggleFlagVisibility("vv-flag--promotion", selectedVariant.hasAttribute('vv-flag--promotion'));
        }
    }

    _vv_updateCurrrentProductMedia() {
        const vv_selected_variant = document.querySelector('.block-swatch input[type="radio"]:checked');
        const vv_variant_media_id = vv_selected_variant.getAttribute("vv-ql-media");
        const vv_current_variant_thumbnail = document.querySelector(`.product__thumbnail-item[vv-ql-media="${vv_variant_media_id}"]`);
        if (vv_variant_media_id && vv_current_variant_thumbnail) {
          vv_current_variant_thumbnail.click();
        }
    }
  
    _vv_updateSetAddToCartLimit() {
        const quick_buy_drawercollection = document.querySelector("quick-buy-drawer[open]");
        if (quick_buy_drawercollection){
        const blockSwatchInputcollection = quick_buy_drawercollection.querySelector('.block-swatch input[type="radio"]:checked')
        const discountTierRadiocollection = quick_buy_drawercollection.querySelector('[name="product-discount-tier"]')
        discountTierRadiocollection?.setAttribute("checked", true); 
        const mirrorInputcollection = document.getElementById("mirrorInput");
        const mirroredInputcollection = quick_buy_drawercollection.querySelector("#mirroredInput"); 
        mirrorInputcollection ? (mirrorInputcollection.value = 1) : null;
        mirroredInputcollection ? (mirroredInputcollection.value = 1) : null; 
        const inventoryQuantitycollection = blockSwatchInputcollection?.getAttribute("inventory-quantity"); 
        //if (inventoryQuantitycollection && inventoryQuantitycollection !== "0") {
        //    mirrorInputcollection?.setAttribute("max", inventoryQuantitycollection);
        //    mirroredInputcollection?.setAttribute("max", inventoryQuantitycollection);
        //}
      } else {
        const blockSwatchInput = document.querySelector('.block-swatch input[type="radio"]:checked');
        const discountTierRadio = document.querySelector('[name="product-discount-tier"]');
        discountTierRadio?.setAttribute("checked", true); 
        const mirrorInput = document.getElementById("mirrorInput");
        const mirroredInput = document.getElementById("mirroredInput"); 
        mirrorInput ? (mirrorInput.value = 1) : null;
        mirroredInput ? (mirroredInput.value = 1) : null; 
        const inventoryQuantity = blockSwatchInput?.getAttribute("inventory-quantity"); 
        //if (inventoryQuantity && inventoryQuantity !== "0") {
        //    mirrorInput?.setAttribute("max", inventoryQuantity);
        //    mirroredInput?.setAttribute("max", inventoryQuantity);
        //}
      }
    }
  
    _updateAddToCartButton(forceAddtoCart) {
        let addToCartButtonElement = this.querySelector("[data-product-add-to-cart-button]");
        if (!addToCartButtonElement) {
            return;
        }
        let addToCartButtonText = "";
        addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
        /*   if (!variant) {
          addToCartButtonElement.setAttribute("disabled", "disabled");
          addToCartButtonElement.classList.add("button--ternary");
          addToCartButtonText =
              window.themeVariables.strings.productFormUnavailable;
 
 
      } else {*/
        if (/*variant["available"] ||*/ forceAddtoCart === "true") {
            addToCartButtonElement.removeAttribute("disabled");
            addToCartButtonElement.classList.add(
                addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary"
            );
            addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content");
        } else {
            addToCartButtonElement.setAttribute("disabled", "disabled");
            addToCartButtonElement.classList.add("button--ternary");
            addToCartButtonText = window.themeVariables.strings.productFormSoldOut;
        }
        /* }*/
        if (addToCartButtonElement.getAttribute("is") === "loader-button") {
            const firstElementChild = addToCartButtonElement.querySelector(".loader-button__text");
            if (firstElementChild) firstElementChild.innerHTML = addToCartButtonText;
        } else {
            addToCartButtonElement.innerHTML = addToCartButtonText;
        }
    }
    _updateDynamicCheckoutButton(/*variant,*/ forceAddtoCart) {
        let paymentButtonElement = this.querySelector(".shopify-payment-button");
        if (!paymentButtonElement) {
            return;
        }
        paymentButtonElement.style.display = forceAddtoCart === "false" ? "none" : "block";
        //  !variant || !variant["available"] ? "none" : "block";
    }
};
window.customElements.define("product-payment-container", PaymentContainer);

// ----------------------- dynamic-menu.js -----------------------

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

/* Animated top-level menu underline */

// Calculate and set the underline to new position
const moveUnderline = (openDetails = null, mainMenu = null, paddingLeft = 0, paddingRight = 0) => {
    const elements = getMenuElements();
    const menuDetailsElement = openDetails === null ? elements.menuDetailsElement : openDetails;
    const menuElement = mainMenu === null ? elements.menuElement : mainMenu;
    const rect = menuDetailsElement && menuDetailsElement.getBoundingClientRect();
    const rectX = !rect || rect.x === 0 ? 12 : rect.x;

    const styles = getComputedStyle(menuDetailsElement.querySelector("summary"));
    paddingLeft = styles.paddingLeft === 0 ? 16 : parseFloat(styles.paddingLeft);
    paddingRight = styles.paddingRight === 0 ? 10 : parseFloat(styles.paddingRight);

    const width = !menuDetailsElement || menuDetailsElement.offsetWidth === 0 ? 71 : menuDetailsElement.offsetWidth;
    const underlineWidth = (width - paddingLeft - paddingRight) / window.innerWidth;

    menuElement.style.setProperty("--underline-scale-x", underlineWidth);
    menuElement.style.setProperty("--underline-position-x", `${rectX + paddingLeft}px`);
};

// Return mobile menu if in mobile view, otherwise return desktop menu
function getMenuElements() {
    const menuElement = document.querySelector("#MobileMainMenu");
    const menuDetailsElement = menuElement.querySelector("details[open]");

    return { menuElement, menuDetailsElement };
}

// Run on initial page load to get initial position, add listener for window resize
moveUnderline();

window.addEventListener("resize", (event) => {
    moveUnderline();
});

// Open first top-level menu item on mouseleave
const headerHoverNavs = document.querySelectorAll("nav.hover-nav");
headerHoverNavs.forEach((headerHover) => {
    headerHover.addEventListener("mouseleave", (event) => {
        const detailsElements = event.currentTarget.querySelectorAll("ul details.menu-level-1");

        detailsElements.forEach((detailsElement, index) => {
            if (index != 0) {
                const summaryElement = detailsElement.querySelector("summary");
                detailsElement.removeAttribute("open");
                summaryElement.setAttribute("aria-expanded", "false");
            }
        });

        const firstElement = detailsElements[0];
        const isOpen = firstElement.hasAttribute("open");
        if (!isOpen) {
            firstElement.setAttribute("open", "");
            firstElement.querySelector("summary").setAttribute("aria-expanded", "true");
        }

        moveUnderline(firstElement);
    });
});

// Open the correct menu item on mouse hover, close other menus and move underline to new position
document.querySelectorAll("details.hover-open").forEach((detailsElement) => {
    detailsElement.addEventListener("mouseenter", (event) => {
        const openDetailsElements = event.currentTarget.closest("ul").querySelectorAll("details[open]");

        if ([...openDetailsElements].find((elem) => elem.className === "menu-opening")) return;

        openDetailsElements.forEach((openDetailsElement) => {
            if (openDetailsElement !== event.target.closest("details")) {
                const summaryElement = openDetailsElement.querySelector("summary");
                openDetailsElement.removeAttribute("open");
                summaryElement.setAttribute("aria-expanded", "false");
            }
        });

        const isOpen = detailsElement.hasAttribute("open");
        if (!isOpen) {
            detailsElement.setAttribute("open", "");
            detailsElement.querySelector("summary").setAttribute("aria-expanded", "true");
        }
        moveUnderline(detailsElement);
    });

    detailsElement.addEventListener("mouseleave", (event) => {
        const openDetailsElements = event.currentTarget.closest("ul").querySelectorAll("details[open]");

        if ([...openDetailsElements].find((elem) => elem.className === "menu-opening")) return;

        openDetailsElements.forEach((openDetailsElement) => {
            if (openDetailsElement !== event.currentTarget) {
                const summaryElement = openDetailsElement.querySelector("summary");
                openDetailsElement.removeAttribute("open");
                summaryElement.setAttribute("aria-expanded", "false");
            }
        });
    });
});

document.querySelectorAll("details.hover-open-submenu").forEach((detailsElement) => {
    let showDelay = 300;
    let hideDelay = 400;
    let menuEnterTimer;
    let menuLeaveTimer;

    detailsElement.addEventListener("mouseenter", (event) => {
        const openDetailsElements = event.currentTarget.closest("ul").querySelectorAll("details[open]");

        clearTimeout(menuLeaveTimer);

        openDetailsElements.forEach((openDetailsElement) => {
            if (openDetailsElement !== event.target.closest("details")) {
                const summaryElement = openDetailsElement.querySelector("summary");
                openDetailsElement.removeAttribute("open");
                summaryElement.setAttribute("aria-expanded", "false");
            }
        });

        const isOpen = detailsElement.hasAttribute("open");
        if (!isOpen) {
            menuEnterTimer = setTimeout(function () {
                detailsElement.setAttribute("open", "");
                detailsElement.querySelector("summary").setAttribute("aria-expanded", "true");
            }, showDelay);
        }
    });

    detailsElement.addEventListener("mouseleave", (event) => {
        clearTimeout(menuEnterTimer);

        const openDetailsElements = event.currentTarget.closest("ul").querySelectorAll("details[open]");
        menuLeaveTimer = setTimeout(function () {
            openDetailsElements.forEach((openDetailsElement) => {
                if (openDetailsElement !== event.currentTarget) {
                    const summaryElement = openDetailsElement.querySelector("summary");
                    openDetailsElement.removeAttribute("open");
                    summaryElement.setAttribute("aria-expanded", "false");
                }
            });
        }, hideDelay);
    });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");

    if (!summary.hasAttribute("aria-expanded")) {
        summary.setAttribute("aria-expanded", "false");
    }

    if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
        if (event.currentTarget.closest("ul")) {
            // Find all open menus on the same level and close them
            const openDetailsElements = event.currentTarget.closest("ul").querySelectorAll("details[open]");
            const detailsElement = event.currentTarget.closest("details");
            const isOpen = detailsElement.hasAttribute("open");

            openDetailsElements.forEach((openDetailsElement) => {
                const summaryElement = openDetailsElement.querySelector("summary");
                openDetailsElement.removeAttribute("open");
                summaryElement.setAttribute("aria-expanded", "false");
            });
        }

        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    if (!container || !elementToFocus) return;
    let elements = getFocusableElements(container);
    let first = elements[0];
    let last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        "ARROWUP",
        "ARROWDOWN",
        "ARROWLEFT",
        "ARROWRIGHT",
        "TAB",
        "ENTER",
        "SPACE",
        "ESCAPE",
        "HOME",
        "END",
        "PAGEUP",
        "PAGEDOWN",
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true
    );
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector("details");
        this.firstLevelMenus = this.querySelectorAll("details.menu-level-1 > summary");

        if (navigator.platform === "iPhone")
            document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents();
        this.mobileMainMenu = document.querySelector("#MobileMainMenu");

        this.closest("mobile-navigation").addEventListener(
            "mobile-nav:open",
            (event) => {
                this.menuPromise = this.upFetchFullMenu();
            },
            { once: true }
        );
    }

    bindEvents() {
        this.querySelectorAll("summary").forEach((summary) =>
            summary.addEventListener("click", this.onSummaryClick.bind(this))
        );
        this.firstLevelMenus.forEach((summary) =>
            summary.addEventListener("mouseenter", this.onSummaryClick.bind(this))
        );
        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onCloseButtonClick.bind(this))
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;

        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute("open");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
            summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add("menu-opening");
                summaryElement.setAttribute("aria-expanded", true);
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
            }, 100);
        }

        if (summaryElement.classList.contains("menu-drawer__menu-level-1")) {
            moveUnderline(detailsElement);
        }

        if (detailsElement.id.includes("Details-menu-drawer-submenu")) {
            this.menuPromise.then(() => this.upParseFullMenu(detailsElement));
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
            // Open first submenu by default
            // this.mainDetailsToggle.querySelector('.menu-drawer__menu > li > details > summary').click();
        });
        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove("menu-opening");
            this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
                //details.removeAttribute('open');
                //details.classList.remove('menu-opening');
            });
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove("menu-opening");
        detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }

    upParseFullMenu(detailsElement) {
        const menuItemSource = this.upHtmlMenu.querySelector(`#${detailsElement.id} ul.menu-drawer__menu`);
        const menuItemDestination = detailsElement.querySelector("ul.menu-drawer__menu");

        if (menuItemSource && menuItemDestination) {
            menuItemDestination.innerHTML = menuItemSource.innerHTML;
        }

        menuItemDestination
            .querySelectorAll("summary")
            .forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));

        menuItemDestination
            .querySelectorAll("button")
            .forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }

    async upFetchFullMenu() {
        return fetch(window.Shopify.routes.root + "?section_id=up-lazy-dynamic-menu")
            .then((response) => response.text())
            .then((responseText) => {
                this.upHtmlMenu = new DOMParser().parseFromString(responseText, "text/html");
            })
            .catch((e) => {
                console.error(e);
            });
    }
}

customElements.define("menu-drawer", MenuDrawer);

// uP Labs - 01-2024
// Defer zevi.ai bundle (search engine)

// Mobile
// document.querySelectorAll("#internal-search-button, .predictive-search__form").forEach((searchbar) => {
//     searchbar.addEventListener(
//         "click",
//         (event) => {
//             const zeviScript = document.createElement("script");
//             zeviScript.src = "https://static.zevi.ai/scripts/suggestions-overlay-willemse-fr-fr.js";
//             zeviScript.async = true;
//             zeviScript.defer = true;
//             document.body.appendChild(zeviScript);

//             if (searchbar.id === "internal-search-button") {
//                 const observer = new MutationObserver(() => {
//                     observer.disconnect();
//                     // console.log("zevi is loaded");
//                     searchbar.click();
//                 });

//                 observer.observe(document.querySelector("html"), {
//                     subtree: false,
//                     childList: false,
//                     attributeFilter: ["style"],
//                 });
//             }
//         },
//         { once: true }
//     );
// });

// Vivetic - get PageFly product redirect url and attaches click event listeners to their corresponding product images on blog page.
window.addEventListener('load', function () {
  var vvPfProductsTitles = document.querySelectorAll('[data-product-type="title"]');
  var vvPfProductImageContainer = document.querySelectorAll(".pf-slide-main-media.is-current");
  if (vvPfProductsTitles.length > 0) {
      var vvPfIteration = 0;
      vvPfProductsTitles.forEach(function(vvPfProduct) {
          var vvPfProductHref = vvPfProduct.getAttribute('data-href');
          vvPfRedirectUrl = "location.href='" + vvPfProductHref +"'";
          vvPfProductImageContainer[vvPfIteration].setAttribute('onclick', vvPfRedirectUrl);
          vvPfIteration++;
      });
  }
})

// Vivetic - Set the height of the static-item element to match the product-item height.  
const _vv_setPromotionBlockHeight = () => {
  const vvProductItem = document.querySelector('.product-item');
  const vvPromotionBlock = document.querySelector('.promotion-block--static-item');
  if (vvProductItem && vvPromotionBlock)
    vvPromotionBlock.style.height = `${vvProductItem.offsetHeight}px`;
};
_vv_setPromotionBlockHeight();
let vvTimer;
window.addEventListener('resize', () => {
  clearTimeout(vvTimer);
  vvTimer = setTimeout(_vv_setPromotionBlockHeight, 300);
});

 //Vivetic - Adjust the height of the blog product to be consistent.
 function _vv_GetLineCount(element) {
    const vvElementHeight = element.offsetHeight;
   const vvLineHeight = parseFloat(getComputedStyle(element).lineHeight);
   return Math.round(vvElementHeight / vvLineHeight);
}
function vvSetLineCount(element, vvLineCount) {
   const vvLineHeight = parseFloat(getComputedStyle(element).lineHeight);
   const vvNewHeight = vvLineHeight * vvLineCount;
   element.style.height = `${vvNewHeight}px`;
}

const vvElements = document.querySelectorAll('[data-product-type="title"]');
if (vvElements.length > 0) {
 let vvMaxLines = 0;
 vvElements.forEach(element => {
     const vvLineCount = _vv_GetLineCount(element);
     if (vvLineCount > vvMaxLines) {
         vvMaxLines = vvLineCount;
     }
 });
 vvElements.forEach(element => {
     vvSetLineCount(element, vvMaxLines);
 });
}

document.addEventListener('DOMContentLoaded', function() {
  const VvProductATC2 = document.querySelectorAll('[data-pf-type="ProductATC2"]');
  if ( VvProductATC2.length > 0 ) {
    VvProductATC2.forEach(element => {
        element.addEventListener('click', function() {
          location.reload();
        });
    });
  }
});

// uP - Play picto vhat video when page fully loaded
window.addEventListener('load', function() {
    const upChatVideo = document.querySelector(".up-static-picto video");
    if (upChatVideo) upChatVideo.play()
}, false);
document.addEventListener("DOMContentLoaded", function() {
    let popupContainer = document.getElementById("vv-varianlql-popup-container");
    let popupImage = document.getElementById("vv-varianlql-popup-image");
    let popupText = document.getElementById("vv-varianlql-popup-text");
    let closePopup = document.getElementById("vv-varianlql-close-popup");

    document.querySelectorAll(".variant-info-icon, .vv-variation-image").forEach(button => {
        button.addEventListener("click", function(event) {
            let vvImageql = null;
            let vvConditionnementDesktop = null;
            let vvConditionnementMobile = null;
            let text = null;

            const blockSwatch = button.closest('.block-swatch');
            if (blockSwatch) {
                const input = blockSwatch.querySelector('input');
                if (input) {
                    vvConditionnementDesktop = input.getAttribute('vv-image_conditionnement_desktop');
                    vvConditionnementMobile = input.getAttribute('vv-image_conditionnement_mobile');
                    vvImageql = input.getAttribute('vv-imageql');
                }
                text = button.getAttribute("data-text");
            }

            if (button.classList.contains("vv-variation-image")) {
                let imgElement = button.querySelector("img"); 
                if (imgElement) {
                    vvImageql = imgElement.getAttribute("src"); 
                }
                text = button.getAttribute("data-text");
            }

            let isMobile = window.innerWidth <= 768;

            let imageSrc = vvImageql;

            if (isMobile && vvConditionnementMobile && vvConditionnementMobile.trim() !== "") {
                imageSrc = vvConditionnementMobile;
            } else if (!isMobile && vvConditionnementDesktop && vvConditionnementDesktop.trim() !== "") {
                imageSrc = vvConditionnementDesktop; 
            }

            if (imageSrc && imageSrc.trim() !== "") {
                popupImage.src = imageSrc;
                popupImage.style.display = "block";
            } else {
                popupImage.style.display = "none";
            }

            if (text && text.trim() !== "") {
                popupText.textContent = text;
                popupText.style.display = "block";
            } else {
                popupText.style.display = "none";
            }

            popupContainer.style.display = "flex";
        });
    });

    closePopup.addEventListener("click", function() {
        popupContainer.style.display = "none";
    });

    popupContainer.addEventListener("click", function(e) {
        if (e.target === popupContainer) {
            popupContainer.style.display = "none";
        }
    });
});

//Pagination image mobile
document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        updateActiveDot();
    });

    document.querySelectorAll('.product__media-item').forEach(item => {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    function updateActiveDot() {
        const selectedItem = document.querySelector('.product__media-item.is-selected');
        if (!selectedItem) return;

        const selectedPosition = parseInt(selectedItem.getAttribute('data-original-position'));

        document.querySelectorAll('.slider-dot').forEach(dot => {
            dot.classList.remove('is-active');
        });

        const activeDot = document.querySelector(`.slider-dot[data-pos="${selectedPosition + 1}"]`);
        if (activeDot) {
            activeDot.classList.add('is-active');
        }
    }

    updateActiveDot();
});

document.addEventListener("DOMContentLoaded", function () {
    let parentElement = document.querySelector(".vv-first-product-judgeme");  
    if (parentElement) {
        let targetElement = parentElement.querySelector(".jdgm-prev-badge__text");
        if (targetElement) {
            targetElement.textContent = targetElement.textContent.replace(/reviews?/, "avis");
        }
    }
});

// VIVETIC - Optimisation du menu willemse pour corriger les bugs sur les scrolls verticals
document.addEventListener('click', (event) => {
    const detailsElement = event.target.closest('details');

    if (detailsElement) {
        if (!detailsElement.classList.contains('hover-open')) {
            const menuLevel = detailsElement.getAttribute('data-level');

            if (menuLevel === 'first-detail-level') {
                submenuElement = detailsElement.querySelector('.menu-drawer__submenu');
            } else if (menuLevel === 'second-detail-level' && submenuElement) {
                submenuElement.style.overflowY = "hidden";
            }
        }
    }
});
document.addEventListener('click', (event) => {
    let target = event.target; 
    let isSecondClosebtn = target.classList.contains('second-menu-drawer__close-button');
    let isFirstClosebtn = target.classList.contains('first-menu-drawer__close-button');

    if (isSecondClosebtn && submenuElement) {
        submenuElement.style.overflowY = "auto";
    } else if (isFirstClosebtn) {
        submenuElement = null;
    }
});

const _vv_showBelgiumFlag = () => {
    fetch("https://api.country.is/")
      .then((response) => {
        if (!response.ok) throw new Error("Erreur réseau");
        return response.json();
      })
      .then((data) => {
        if (data.country === "BE") {
          // Ajoute la classe pour les deux versions
          document.querySelector(".vv-belge-flag")?.classList.add("is-belgium");
          document
            .querySelector(".vv-belge-flag-mobile")
            ?.classList.add("is-belgium");
        }
      })
      .catch((error) => {
        console.error("Détection du pays impossible:", error);
      });
}
  
// Lancement au chargement
window.addEventListener("load", _vv_showBelgiumFlag);

// FAQ

document.addEventListener("DOMContentLoaded", function() {
    // Gestion des onglets Desktop
    const tabs = document.querySelectorAll(".conseil-pro .tab");
    const contents = document.querySelectorAll(".conseil-pro .tab-content");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        tab.classList.add("active");
        document.getElementById(tab.dataset.tab).classList.add("active");
      });
    });

    // Gestion des questions FAQ Mobile
    const questions = document.querySelectorAll(".faq-question");
    questions.forEach((question) => {
      question.addEventListener("click", function() {
        this.classList.toggle("active");
        const answer = this.nextElementSibling;
        if (this.classList.contains("active")) {
          answer.style.display = "block";
        } else {
          answer.style.display = "none";
        }
      });
    });
  });
